import { Button } from "@/components/ui/button";
import { ArrowRight, Radar } from "lucide-react";
import { Link } from "react-router-dom";
import SellerIdentity from "@/components/SellerIdentity";


const FinalCTA = () => (
  <section className="relative py-32 overflow-hidden">
    <div className="absolute inset-0 bg-hero-radial" />
    <div className="absolute inset-0 bg-grid pointer-events-none" />
    <div className="container relative">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-display text-5xl md:text-7xl font-bold leading-[0.95]">
          Or keep launching <span className="text-muted-foreground line-through">what already peaked.</span>
        </h2>
        <p className="mt-8 text-lg text-muted-foreground max-w-xl mx-auto">
          Tomorrow's best-sellers are already showing up in our scans tonight.
          The question is whether you'll see them before your competitors do.
        </p>
        <div className="mt-10">
          <Button variant="hero" size="xl" asChild>
            <a href="#pricing">
              Get My First 10 Trends <ArrowRight />
            </a>
          </Button>
        </div>
      </div>
    </div>

    <footer className="container relative mt-32 pt-10 border-t border-border text-sm text-muted-foreground">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="grid place-items-center w-6 h-6 rounded bg-primary text-primary-foreground">
            <Radar className="w-3 h-3" />
          </span>
          <span className="font-display font-semibold text-foreground">Trends.Discovery</span>
          <span>© 2026</span>
        </div>
        <nav aria-label="Legal and support" className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-xs">
          <a href="#pricing" className="hover:text-foreground transition-colors">$39 Lifetime</a>
          <Link to="/about" className="hover:text-foreground transition-colors">About Skaiboss</Link>
          <Link to="/account" className="hover:text-foreground transition-colors">Customer portal</Link>
          <Link to="/marketplace" className="hover:text-foreground transition-colors">Marketplace</Link>

          <Link to="/roadmap" className="hover:text-foreground transition-colors">Roadmap</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
          <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
          <Link to="/support" className="hover:text-foreground transition-colors">Support</Link>
        </nav>
      </div>
      <SellerIdentity className="mt-6 max-w-3xl" />
    </footer>

  </section>
);

export default FinalCTA;
